import React, { useState, useEffect } from "react";
import {
  Container,
  Content,
  MainDash,
  SubTitle,
  ButtonDiv,
  ContainerPizza,
  SearchButton,
  GridTemplate,
  BoxLoader,
  FlexTemplate,
  MainDashExternal,
} from "./styles-dash";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import AbsoluteData from "../../../components/Admin/Dashboard/MainDashboard/AbsoluteData";
import AbsoluteDataFinantial from "../../../components/Admin/Dashboard/MainDashboard/AbsoluteDataFinantial";
import Activity from "../../../components/Admin/Dashboard/MainDashboard/Activity";
import NpsGraph from "../../../components/Admin/Dashboard/MainDashboard/NpsGraph";
import { producaov2, local } from "../../../services/apis";
import { formatDateToMySQL, converterData } from "../../../utils/Utils";
import { Box, Button, Grid, TextField } from "@material-ui/core";
import { Loader } from "semantic-ui-react";
import Loading from "../../../components/Loader";
import {
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableCell,
  TableBody,
  Table,
} from "@material-ui/core";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import AbsoluteDataOperationArea from "../../../components/Admin/Dashboard/MainDashboard/AbsoluteDataOperationArea";
import GeneralDataCS from "../../../components/Admin/Dashboard/GeneralDataCSV2";
// import DashboardMBA from '../../../components/Admin/Dashboard/MBA';
import cleanTitle from "../../../utils/cleanTitle";
import { orderByDate } from "../../../helpers/Dashboard";
import ActivityFinantial from "../../../components/Admin/Dashboard/MainDashboard/ActivityFinantial";
import DataTable from "../../../components/DataTable";
import GeneralDataCSV3 from "../../../components/Admin/Dashboard/GeneralDataCSV3";
// import DashboardMBA from '../../../components/Admin/Dashboard/MBA';

const Dashboard = (props) => {
  const getPassDate = () => {
    const today = new Date();
    const pastDate = new Date(today.setMonth(today.getMonth() - 1));
    return pastDate.toISOString().split("T")[0]; // Formata a data para 'YYYY-MM-DD'
  };

  ChartJS.register(ArcElement, Tooltip, Legend);
  // Main Frame
  const [dataMainFrame, setDataMainFrame] = useState();
  const [loadingResendMainFrame, setLoadingResendMainFrame] = useState(false);
  const [dataInicioMainFrame, setDataInicioMainFrame] = useState(getPassDate());
  const [dataFimMainFrame, setDataFimMainFrame] = useState(
    formatDateToMySQL(new Date())
  );

  // Operational Frame
  const [dataOperationalFrame, setDataOperationalFrame] = useState();
  const [
    loadingResendOperationalFrame,
    setLoadingResendOperationalFrame,
  ] = useState(false);
  // const [dataInicioOperationalFrame, setDataInicioOperationalFrame] = useState("2015-01-01");
  // const [dataFimOperationalFrame, setDataFimOperationalFrame] = useState(formatDateToMySQL(new Date()));

  // Produtos Frame
  const [dataProdutoFrame, setDataProdutoFrame] = useState();
  const [loadingResendProdutoFrame, setLoadingResendProdutoFrame] = useState(
    false
  );

  // Inscription PAGE
  const [dataInscription, setDataInscription] = useState();
  // const [loadingDataInscriptionrame, setLoadingDataInscription] = useState(false);
  const [
    loadingResendMainFrameInscriptions,
    setLoadingResendMainFrameInscriptions,
  ] = useState(false);

  // Finantial PAGE
  const [dataFinantial, setDataFinantial] = useState();
  const [loadingResendFinantial, setLoadingResendFinantial] = useState(false);

  const handleStartDateChange = (date, frame) => {
    setDataInicioMainFrame(date);
    // if(frame = "mainFrame") {
    //   setDataInicioMainFrame(date);
    // }
    // if(frame = "operationalFrame") {
    //   setDataInicioOperationalFrame(date);
    // }
  };
  const handleEndDateChange = (date, frame) => {
    setDataFimMainFrame(date);
    // if(frame = "mainFrame") {
    //   setDataFimMainFrame(date);
    // }
    // if(frame = "operationalFrame") {
    //   setDataFimOperationalFrame(date);
    // }
  };
  // Request que traz os dados do Main Frame
  async function resendMainFrame() {
    setLoadingResendMainFrame(true);
    try {
      const response = await producaov2.get(
        `admin/dashboard/main?data_inicio=${dataInicioMainFrame}&data_fim=${dataFimMainFrame}`
      );
      if (response.data) {
        setDataMainFrame(response.data);
        setLoadingResendMainFrame(false);
        return;
      }
    } catch (error) {
      console.error(error);
      setLoadingResendMainFrame(false);
    }
  }
  // Request que traz os dados do inscricao
  async function resendMainFrameInscriptions() {
    setLoadingResendMainFrameInscriptions(true);
    try {
      const response = await producaov2.get(
        `admin/dashboard/main-inscription?data_inicio=${dataInicioMainFrame}&data_fim=${dataFimMainFrame}`
      );
      if (response.data) {
        setDataInscription(response.data);
        setLoadingResendMainFrameInscriptions(false);
        return;
      }
    } catch (error) {
      console.error(error);
      setLoadingResendMainFrameInscriptions(false);
    }
  }
  // Request que traz os dados do Operational Frame
  async function resendOperationalFrame() {
    setLoadingResendOperationalFrame(true);
    try {
      const response = await producaov2.get(
        `admin/dashboard/main-csop?data_inicio=${dataInicioMainFrame}&data_fim=${dataFimMainFrame}`
      );
      if (response.data) {
        setDataOperationalFrame(response.data);
        setLoadingResendOperationalFrame(false);
        return;
      }
    } catch (error) {
      console.error(error);
      setLoadingResendOperationalFrame(false);
    }
  }

  // Request que traz os dados do Produto
  async function resendProdutolFrame() {
    setLoadingResendProdutoFrame(true);
    try {
      const response = await producaov2.get(
        `admin/dashboard/main-produtos?data_inicio=${dataInicioMainFrame}&data_fim=${dataFimMainFrame}`
      );
      if (response.data) {
        setDataProdutoFrame(response.data);
        setLoadingResendProdutoFrame(false);
        return;
      }
    } catch (error) {
      console.error(error);
      setLoadingResendProdutoFrame(false);
    }
  }
  // Request que traz os dados do Financeiros
  async function resendFinantialframe() {
    setLoadingResendFinantial(true);
    try {
      const response = await producaov2.get(
        `admin/dashboard/main-finantial?data_inicio=${dataInicioMainFrame}&data_fim=${dataFimMainFrame}`
      );
      if (response.data) {
        setDataFinantial(response.data);
        setLoadingResendFinantial(false);
        return;
      }
    } catch (error) {
      console.error(error);
      setLoadingResendFinantial(false);
    }
  }

  useEffect(() => {
    // async function getData() {
    //   setLoading(true);
    //   try {
    //     const response = await local.get(`admin/dashboard/main?data_inicio=${dataInicio}&data_fim=${dataFim}`);
    //     if (response.data) {
    //       console.log("RESPONSE:", response.data)
    //       setDataMainFrame(response.data);
    //       setLoading(false);
    //       return;
    //     }
    //   } catch (error) {
    //     console.error(error);
    //     setLoading(false);
    //   }
    // };
    resendMainFrameInscriptions();
    resendMainFrame();
    resendOperationalFrame();
    resendProdutolFrame();
    resendFinantialframe();
  }, []);

  async function resendAll() {
    resendMainFrameInscriptions();
    resendMainFrame();
    resendOperationalFrame();
    resendProdutolFrame();
    resendFinantialframe();
  }

  const configPagos = {
    responsive: true,
    labels: dataInscription?.topCursosPagos?.map((curso) => curso.curso) || [],
    datasets: [
      {
        data:
          dataInscription?.topCursosPagos?.map((curso) => curso.quantidade) ||
          [],
        backgroundColor: [
          "rgba(255, 99, 132, 0.8)",
          "rgba(255, 159, 64, 0.8)",
          "rgba(255, 205, 86, 0.8)",
          "rgba(75, 192, 192, 0.8)",
          "rgba(54, 162, 235, 0.8)",
          "rgba(153, 102, 255, 0.8)",
          "rgba(201, 203, 207, 0.8)",
          "rgba(255, 159, 64, 0.8)",
          "rgba(75, 192, 192, 0.8)",
          "rgba(54, 162, 235, 0.8)",
        ],
      },
    ],
  };

  const configGratuitos = {
    labels:
      dataInscription?.topCursosGratuitos?.map((curso) => curso.curso) || [],
    datasets: [
      {
        data:
          dataInscription?.topCursosGratuitos?.map(
            (curso) => curso.quantidade
          ) || [],
        backgroundColor: [
          "rgba(255, 99, 132, 0.8)",
          "rgba(255, 159, 64, 0.8)",
          "rgba(255, 205, 86, 0.8)",
          "rgba(75, 192, 192, 0.8)",
          "rgba(54, 162, 235, 0.8)",
          "rgba(153, 102, 255, 0.8)",
          "rgba(201, 203, 207, 0.8)",
          "rgba(255, 159, 64, 0.8)",
          "rgba(75, 192, 192, 0.8)",
          "rgba(54, 162, 235, 0.8)",
        ],
      },
    ],
    options: {
      plugins: {
        legend: {
          display: false,
        },
      },
    },
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <h2>
            Painel de Gestão Acadêmica<small></small>
          </h2>
          <MainDashExternal>
            <header>
              <ButtonDiv>
                <TextField
                  label="Data de Início"
                  type="date"
                  value={dataInicioMainFrame}
                  onChange={(e) =>
                    handleStartDateChange(e.target.value, "mainFrame")
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <TextField
                  label="Data de Fim"
                  type="date"
                  value={dataFimMainFrame}
                  onChange={(e) =>
                    handleEndDateChange(e.target.value, "mainFrame")
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resendAll()}
                >
                  Consultar
                </Button>
              </ButtonDiv>
            </header>
            <SubTitle href="/admin/inscricoes">Gestão de Alunos</SubTitle>
            <MainDash>
              {loadingResendMainFrame ? (
                <div
                  style={{ width: "100%", height: "200px", margin: "0 auto" }}
                >
                  <BoxLoader>
                    <Loading noText div />
                  </BoxLoader>
                </div>
              ) : (
                <GridTemplate isFlex>
                  {dataMainFrame ? (
                    <>
                      <AbsoluteData data={dataMainFrame} />
                      {dataMainFrame?.graph_active_day_by_day ? (
                        <Activity
                          graph_active_day_by_day={
                            dataMainFrame.graph_active_day_by_day
                          }
                        />
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <center>Ocorreu um erro</center>
                  )}
                </GridTemplate>
              )}
            </MainDash>
            <SubTitle href="/admin/faturasv2">Gestão Financeira</SubTitle>
            <MainDash>
              {loadingResendFinantial ? (
                <div
                  style={{ width: "100%", height: "200px", margin: "0 auto" }}
                >
                  <BoxLoader>
                    <Loading noText div />
                  </BoxLoader>
                </div>
              ) : (
                <GridTemplate isFlex>
                  {dataFinantial ? (
                    <>
                      <AbsoluteDataFinantial data={dataFinantial} />
                      {dataFinantial?.graph_active_day_by_day ? (
                        <ActivityFinantial
                          graph_active_day_by_day={
                            dataFinantial.graph_active_day_by_day
                          }
                        />
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <center>Ocorreu um erro</center>
                  )}
                </GridTemplate>
              )}
            </MainDash>
          </MainDashExternal>
          <h2>Gestão de Inscrições</h2>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "1rem",
              marginBottom: "2rem",
            }}
          >
            {loadingResendMainFrameInscriptions ? (
              <div style={{ width: "100%", height: "200px", margin: "0 auto" }}>
                <BoxLoader>
                  <Loading noText div />
                </BoxLoader>
              </div>
            ) : (
              <>
                <Box width="100%">
                  <DataTable
                    hasStickHeader
                    showFilters={false}
                    showPagination={false}
                    maxHeight="400px"
                    rowsPerPage={5}
                    columns={[
                      { key: "month", name: "Mês/Ano" },
                      { key: "paid", name: "Pago" },
                      { key: "free", name: "Gratuito" },
                    ]}
                    rows={dataInscription?.pagamentosPorMes?.map((data) => ({
                      month: converterData(data?.mes),
                      paid: data?.pagos,
                      free: data?.gratuitos,
                    }))}
                  />
                </Box>
              </>
            )}
          </div>

          {loadingResendMainFrameInscriptions ? (
            <div style={{ width: "100%", height: "200px", margin: "0 auto" }}>
              <BoxLoader>
                <Loading noText div />
              </BoxLoader>
            </div>
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <DataTable
                    showFilters={false}
                    showPagination={false}
                    hasStickHeader
                    maxHeight="400px"
                    columns={[
                      { key: "course", name: "Cursos Pagos" },
                      {
                        key: "acquisition",
                        name: "Aquisições",
                        align: "center",
                      },
                      { key: "value", name: "Faturamento", align: "center" },
                    ]}
                    rows={dataInscription?.topCursosPagos?.map((data) => ({
                      course: cleanTitle(data?.curso),
                      acquisition: data?.quantidade,
                      value: data?.total_pago,
                    }))}
                    rowsPerPage={5}
                  />
                </Grid>
                <Grid item xs={6}>
                  <DataTable
                    showFilters={false}
                    showPagination={false}
                    hasStickHeader
                    maxHeight="400px"
                    columns={[
                      { key: "course", name: "Cursos Gratuitos" },
                      {
                        key: "acquisition",
                        name: "Aquisições",
                        align: "center",
                      },
                    ]}
                    rows={dataInscription?.topCursosGratuitos?.map((data) => ({
                      course: cleanTitle(data?.curso),
                      acquisition: data?.quantidade,
                    }))}
                    rowsPerPage={5}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Content>

        <Content>
          <h2>Gestão de Operações</h2>
          <MainDashExternal>
            <MainDash>
              {loadingResendOperationalFrame ? (
                <div
                  style={{ width: "100%", height: "200px", margin: "0 auto" }}
                >
                  <BoxLoader noText div>
                    <Loading />
                  </BoxLoader>
                </div>
              ) : (
                <GridTemplate isFlex>
                  {dataOperationalFrame ? (
                    <>
                      <AbsoluteDataOperationArea
                        data={dataOperationalFrame}
                        npsGeral={dataProdutoFrame?.media_geral_nps}
                      />
                      {dataProdutoFrame?.graph?.mediasDiariasGerais ? (
                        <NpsGraph
                          graph_active_day_by_day={orderByDate(
                            dataProdutoFrame?.graph?.mediasDiariasGerais
                          )}
                        />
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <center>Ocorreu um erro</center>
                  )}
                </GridTemplate>
              )}
            </MainDash>
            <Box width="100%">
              {loadingResendProdutoFrame ? (
                <>
                  <BoxLoader noText div>
                    <Loading />
                  </BoxLoader>
                  <BoxLoader noText div>
                    <Loading />
                  </BoxLoader>
                </>
              ) : dataProdutoFrame ? (
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <DataTable
                        showFilters={false}
                        showPagination={false}
                        hasStickHeader
                        maxHeight="400px"
                        columns={[
                          {
                            key: "course",
                            name: "Cursos Top 10 (>20 avaliações)",
                          },
                          {
                            key: "rating",
                            name: "Avaliações",
                            align: "center",
                          },
                          { key: "nps", name: "NPS", align: "center" },
                        ]}
                        rows={dataProdutoFrame?.nps?.top10?.map((data) => ({
                          course: cleanTitle(data?.curso),
                          rating: data?.avaliacoes,
                          nps: `${data?.media}%`,
                        }))}
                        rowsPerPage={5}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <DataTable
                        showFilters={false}
                        showPagination={false}
                        hasStickHeader
                        maxHeight="400px"
                        columns={[
                          {
                            key: "course",
                            name: "Cursos Under 10 (>20 avaliações)",
                          },
                          {
                            key: "rating",
                            name: "Avaliações",
                            align: "center",
                          },
                          { key: "nps", name: "NPS", align: "center" },
                        ]}
                        rows={dataProdutoFrame?.nps?.under10?.map((data) => ({
                          course: cleanTitle(data?.curso),
                          rating: data?.avaliacoes,
                          nps: `${data?.media}%`,
                        }))}
                        rowsPerPage={5}
                      />
                    </Grid>
                  </Grid>
                </>
              ) : (
                <center>Ocorreu um erro</center>
              )}
            </Box>
          </MainDashExternal>
        </Content>
        <GeneralDataCSV3
          key={`${dataInicioMainFrame}-${dataFimMainFrame}`}
          startDate={dataInicioMainFrame}
          endDate={dataFimMainFrame}
        />
      </Container>

      {/* <DashboardMBA /> */}
    </>
  );
};
export default Dashboard;
